import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";
import Header from "@components/shared/header";
import colors from "@styles/variables/storagecontainerpricesVariables.module.scss";
import StorageContainerLogo from "@components/storagecontainerprices/logo";
import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import StorageContainerWrapper from "@components/layouts/storagecontainerpricesWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <StorageContainerWrapper>
            <Header
                slogan="find the best storage container prices"
                textColor={colors.offerCallNumber}
                backGroundColor="#f4f4f4"
            >
                <StorageContainerLogo />
            </Header>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#00a8b1" />
                </div>
                <FormSection iconsFillColor="#00a8b1" />
            </div>
        </StorageContainerWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
